import {useContext} from 'react';
import {Switch} from 'react-router-dom';
import Route from './Route';

import {AuthContext} from '../contexts/auth';

import SigIn from '../pages/SigIn';
import Dashboard from '../pages/Dashboard';

import Users from '../pages/Registers/Users';
import CadUsers from '../pages/Registers/Users/insert';

import Permission from '../pages/Settings/Permission';
import CadPermission from '../pages/Settings/Permission/insert';

import People from '../pages/Registers/People';
import CadPeople from '../pages/Registers/People/insert';

import Companies from '../pages/Registers/Companies';
import CadCompanies from '../pages/Registers/Companies/insert';

import Profiles from '../pages/Registers/Profiles';
import CadProfiles from '../pages/Registers/Profiles/insert';

import Parameters from '../pages/Settings/Parameters';
import CadParameters from '../pages/Settings/Parameters/insert';

import Generics from '../pages/Settings/Generics';
import CadGenerics from '../pages/Settings/Generics/insert';

import Units from '../pages/Registers/Units';
import CadUnits from '../pages/Registers/Units/insert';

import GroupProducts from '../pages/Registers/GroupProducts';
import CadGroupProducts from '../pages/Registers/GroupProducts/insert';

import GroupCompanies from '../pages/Registers/GroupCompanies';
import CadGroupCompanies from '../pages/Registers/GroupCompanies/insert';

import TypesProduct from '../pages/Registers/TypesProduct';
import CadTypesProduct from '../pages/Registers/TypesProduct/insert';

import Warehouses from '../pages/Registers/Warehouses';
import CadWarehouses from '../pages/Registers/Warehouses/insert';

import StorageZones from '../pages/Registers/StorageZones';
import CadStorageZones from '../pages/Registers/StorageZones/insert';

import Products from '../pages/Registers/Products';
import CadProducts from '../pages/Registers/Products/insert';

import Adresses from '../pages/Registers/Adresses';
import CadAdresses from '../pages/Registers/Adresses/insert';

import EntryDocuments from '../pages/Operations/EntryDocuments';
import CadEntryDocuments from '../pages/Operations/EntryDocuments/insert';

import ReceiptDocuments from '../pages/Operations/ReceiptDocuments';
import CadReceiptDocuments from '../pages/Operations/ReceiptDocuments/insert';

import ProductsRequests from '../pages/Operations/ProductRequests';
import CadProductsRequests from '../pages/Operations/ProductRequests/insert';

import EPIRequests from '../pages/Operations/EPIRequests';
import CadEPIRequests from '../pages/Operations/EPIRequests/insert';

import Services from '../pages/Registers/Services';
import CadServices from '../pages/Registers/Services/insert';

import AddressControl from '../pages/Operations/AddressControl';
import AddressControlCad from '../pages/Operations/AddressControl/insert';

import OrderServices from '../pages/Operations/OrderService';
import CadOrderServices from '../pages/Operations/OrderService/insert';

import Tag from '../pages/Operations/Tags';
import CadTag from '../pages/Operations/Tags/insert';

import Balance from '../pages/Reports/Balances';

import ImportData from '../pages/Settings/ImportData';

import Kardex from '../pages/Reports/Kardex';

import Conferred from '../pages/Reports/Conferred';

import OrderPoint from '../pages/Operations/OrderPoint';

import ManualMoviment from '../pages/Operations/ManualMoviment';
import AverageCost from '../pages/Operations/AverageCost';
import Movements from '../pages/Reports/Movements';
import StockPosition from '../pages/Reports/StockPosition';

import ReturnRequest from '../pages/Operations/ReturnRequest';
import CadReturnRequest from '../pages/Operations/ReturnRequest/insert';

import Inventory from '../pages/Operations/Inventory';
import CadInventory from '../pages/Operations/Inventory/insert';
import EditInventory from '../pages/Operations/Inventory/edit';

import Features from '../pages/Settings/Features';
import CadFeatures from '../pages/Settings/Features/insert';
import PasswordReset from "../pages/PasswordReset";
import PasswordRecovery from "../pages/PasswordRecovery";
import Messages from '../pages/Registers/Messages';
import CadMessages from '../pages/Registers/Messages/insert';
import SeparationConference from '../pages/SeparationConference';
import Employees from '../pages/Registers/Employees';
import CadEmployees from '../pages/Registers/Employees/insert';
import Logs from '../pages/Reports/Logs';
import IntegrationLog from '../pages/Reports/IntegrationLog';
import URLs from '../pages/Settings/URLs';
import CadURLs from '../pages/Settings/URLs/insert';
import GeneralParameters from '../pages/Settings/GeneralParameters';
import CadGeneralParameters from '../pages/Settings/GeneralParameters/insert';
import ParametersByCompany from '../pages/Settings/ParametersByCompanies';
import CadParametersByCompanies from '../pages/Settings/ParametersByCompanies/insert';
import CommitedBalances from '../pages/Reports/CommitedBalances';
import QRCode from '../pages/Settings/QRCode';

export default function Routes() {
        const {signOut} = useContext(AuthContext);

        return (
            <Switch>
                    <Route exact path="/" component={SigIn}/>
                    <Route exact path="/password/reset" component={PasswordReset}/>
                    <Route exact path="/password/recovery" component={PasswordRecovery}/>
                    <Route exact path="/dashboard" component={Dashboard} isPrivate/>

                    <Route exact path="/users" component={Users} isPrivate/>
                    <Route exact path="/users/cadastrar" component={CadUsers} isPrivate/>
                    <Route exact path="/users/cadastrar/:option:id" component={CadUsers} isPrivate/>

                    <Route exact path="/permissions" component={Permission} isPrivate/>
                    <Route exact path="/permissions/cadastrar" component={CadPermission} isPrivate/>
                    <Route exact path="/permissions/cadastrar/:option:id" component={CadPermission} isPrivate/>

                    <Route exact path="/import_data" component={ImportData} isPrivate/>

                    <Route exact path="/people" component={People} isPrivate/>
                    <Route exact path="/people/cadastrar" component={CadPeople} isPrivate/>
                    <Route exact path="/people/cadastrar/:option:id" component={CadPeople} isPrivate/>

                    <Route exact path="/companies" component={Companies} isPrivate/>
                    <Route exact path="/companies/cadastrar" component={CadCompanies} isPrivate/>
                    <Route exact path="/companies/cadastrar/:option:id" component={CadCompanies} isPrivate/>

                    <Route exact path="/profiles" component={Profiles} isPrivate/>
                    <Route exact path="/profiles/cadastrar" component={CadProfiles} isPrivate/>
                    <Route exact path="/profiles/cadastrar/:option:id" component={CadProfiles} isPrivate/>

                    <Route exact path="/parameters" component={Parameters} isPrivate/>
                    <Route exact path="/parameters/cadastrar" component={CadParameters} isPrivate/>
                    <Route exact path="/parameters/cadastrar/:option:id" component={CadParameters} isPrivate/>

                    <Route exact path="/general_parameters" component={GeneralParameters} isPrivate/>
                    <Route exact path="/general_parameters/cadastrar" component={CadGeneralParameters} isPrivate/>
                    <Route exact path="/general_parameters/cadastrar/:option:id" component={CadGeneralParameters} isPrivate/>

                    <Route exact path="/companies_parameters" component={ParametersByCompany} isPrivate/>
                    <Route exact path="/companies_parameters/cadastrar" component={CadParametersByCompanies} isPrivate/>
                    <Route exact path="/companies_parameters/parameter/:id/cadastrar/:option:id" component={CadParametersByCompanies} isPrivate/>

                    <Route exact path="/urls" component={URLs} isPrivate />
                    <Route exact path="/urls/cadastrar" component={CadURLs} isPrivate />
                    <Route exact path="/urls/cadastrar/:option:id" component={CadURLs} isPrivate />

                    <Route exact path="/generics" component={Generics} isPrivate/>
                    <Route exact path="/generics/cadastrar" component={CadGenerics} isPrivate/>
                    <Route exact path="/generics/cadastrar/:option:id" component={CadGenerics} isPrivate/>

                    <Route exact path="/features" component={Features} isPrivate/>
                    <Route exact path="/features/cadastrar" component={CadFeatures} isPrivate/>
                    <Route exact path="/features/cadastrar/:option:id" component={CadFeatures} isPrivate/>

                    <Route exact path="/qr_code" component={QRCode} isPrivate />

                    <Route exact path="/units" component={Units} isPrivate/>
                    <Route exact path="/units/cadastrar" component={CadUnits} isPrivate/>
                    <Route exact path="/units/cadastrar/:option:id" component={CadUnits} isPrivate/>

                    <Route exact path="/group_products" component={GroupProducts} isPrivate/>
                    <Route exact path="/group_products/cadastrar" component={CadGroupProducts} isPrivate/>
                    <Route exact path="/group_products/cadastrar/:option:id" component={CadGroupProducts} isPrivate/>

                    <Route exact path="/types_product" component={TypesProduct} isPrivate/>
                    <Route exact path="/types_product/cadastrar" component={CadTypesProduct} isPrivate/>
                    <Route exact path="/types_product/cadastrar/:option:id" component={CadTypesProduct} isPrivate/>

                    <Route exact path="/warehouses" component={Warehouses} isPrivate/>
                    <Route exact path="/warehouses/cadastrar" component={CadWarehouses} isPrivate/>
                    <Route exact path="/warehouses/cadastrar/:option:id" component={CadWarehouses} isPrivate/>

                    <Route exact path="/storage_zones" component={StorageZones} isPrivate/>
                    <Route exact path="/storage_zones/cadastrar" component={CadStorageZones} isPrivate/>
                    <Route exact path="/storage_zones/cadastrar/:option:id" component={CadStorageZones} isPrivate/>

                    <Route exact path="/address_control" component={AddressControl} isPrivate/>
                    <Route exact path="/address_control/cadastrar" component={AddressControlCad} isPrivate/>
                    <Route exact path="/address_control/cadastrar/:option:id" component={AddressControlCad} isPrivate/>

                    <Route exact path="/products" component={Products} isPrivate/>
                    <Route exact path="/products/cadastrar" component={CadProducts} isPrivate/>
                    <Route exact path="/products/cadastrar/:option:id" component={CadProducts} isPrivate/>

                    <Route exact path="/group_companies" component={GroupCompanies} isPrivate/>
                    <Route exact path="/group_companies/cadastrar" component={CadGroupCompanies} isPrivate/>
                    <Route exact path="/group_companies/cadastrar/:option:id" component={CadGroupCompanies} isPrivate/>

                    <Route exact path="/adresses" component={Adresses} isPrivate/>
                    <Route exact path="/adresses/cadastrar" component={CadAdresses} isPrivate/>
                    <Route exact path="/adresses/cadastrar/:option:id" component={CadAdresses} isPrivate/>

                    <Route exact path="/inventory" component={Inventory} isPrivate/>
                    <Route exact path="/inventory/cadastrar" component={CadInventory} isPrivate/>
                    <Route exact path="/inventory/cadastrar/:option:id" component={EditInventory} isPrivate/>

                    <Route exact path="/entry_documents" component={EntryDocuments} isPrivate/>
                    <Route exact path="/entry_documents/cadastrar" component={CadEntryDocuments} isPrivate/>
                    <Route exact path="/entry_documents/cadastrar/:option:id" component={CadEntryDocuments} isPrivate/>

                    <Route exact path="/receipt_documents" component={ReceiptDocuments} isPrivate/>
                    <Route exact path="/receipt_documents/cadastrar" component={CadReceiptDocuments} isPrivate/>
                    <Route exact path="/receipt_documents/cadastrar/:option:id" component={CadReceiptDocuments}
                           isPrivate/>

                    <Route exact path="/product_requests" component={ProductsRequests} isPrivate/>
                    <Route exact path="/product_requests/cadastrar" component={CadProductsRequests} isPrivate/>
                    <Route exact path="/product_requests/cadastrar/:option:id" component={CadProductsRequests}
                           isPrivate/>

                    <Route exact path="/epis_requests" component={EPIRequests} isPrivate />
                    <Route exact path="/epis_requests/cadastrar" component={CadEPIRequests} isPrivate />
                    <Route exact path="/epis_requests/cadastrar/:option:id" component={CadEPIRequests} isPrivate />

                    <Route exact path="/return_request" component={ReturnRequest} isPrivate/>
                    <Route exact path="/return_request/cadastrar" component={CadReturnRequest} isPrivate/>
                    <Route exact path="/return_request/cadastrar/:option:id" component={CadReturnRequest} isPrivate/>

                    <Route exact path="/average_cost" component={AverageCost} isPrivate/>

                    <Route exact path="/services" component={Services} isPrivate/>
                    <Route exact path="/services/cadastrar" component={CadServices} isPrivate/>
                    <Route exact path="/services/cadastrar/:option:id" component={CadServices} isPrivate/>

                    <Route exact path="/order_services" component={OrderServices} isPrivate/>
                    <Route exact path="/order_services/cadastrar" component={CadOrderServices} isPrivate/>
                    <Route exact path="/order_services/cadastrar/:option:id" component={CadOrderServices} isPrivate/>

                    <Route exact path="/tags" component={Tag} isPrivate/>
                    <Route exact path="/tags/cadastrar" component={CadTag} isPrivate/>
                    <Route exact path="/tags/cadastrar/:option:id" component={CadTag} isPrivate/>

                    <Route exact path="/messages" component={Messages} isPrivate/>
                    <Route exact path="/messages/cadastrar" component={CadMessages} isPrivate/>
                    <Route exact path="/messages/cadastrar/:option:id" component={CadMessages} isPrivate/>

                    <Route exact path="/employees" component={Employees} isPrivate/>
                    <Route exact path="/employees/cadastrar" component={CadEmployees} isPrivate/>
                    <Route exact path="/employees/cadastrar/:option:id" component={CadEmployees} isPrivate/>

                    <Route exact path="/separation-conference" component={SeparationConference} isPrivate/>

                    <Route exact path="/balances" component={Balance} isPrivate/>

                    <Route exact path="/movements" component={Movements} isPrivate/>

                    <Route exact path="/stock_position" component={StockPosition} isPrivate/>

                    <Route exact path="/logs" component={Logs} isPrivate />
                    
                    <Route exact path="/integration_error" component={IntegrationLog} isPrivate />

                    <Route exact path="/kardex" component={Kardex} isPrivate/>

                    <Route exact path="/conferred" component={Conferred} isPrivate/>

                    <Route exact path="/order_point" component={OrderPoint} isPrivate/>

                    <Route exact path="/manual_movement" component={ManualMoviment} isPrivate/>

                    <Route exact path="/commitment" component={CommitedBalances} isPrivate/>

                    <Route exact path="/sair" component={signOut} isPrivate/>
            </Switch>
        )
}